import React from 'react';
import PropTypes from 'prop-types';
import styles from './DefaultSelect.module.css';


const DefaultSelect = (props) => {
  return (
    <div className={!props.styles && styles.DefaultSelect}>
      <h2 className="subtitle">{props.title}</h2>
      <select className="selectBusca">
        {props.options.map(({ value, label }) => {
          return (<option value={value} >{label}</option>)
        })}
      </select>
    </div>
  )
};

DefaultSelect.propTypes = {
  options: PropTypes.object,
  title: PropTypes.string,
  styles: PropTypes.string
};

DefaultSelect.defaultProps = {};

export default DefaultSelect;
